import styled from '@emotion/styled';
import FormLabel from 'components/form_factory/form_label';

export const FieldLabel = styled(FormLabel)`
  color: #333;
  display: block;
  font-size: 18px !important;
  font-weight: bold;
  margin: 0 0 18px 0;
  text-transform: none !important;
`;

export const StyledTextarea = styled.textarea`
  field-sizing: content;
  min-height: 60px;
  max-height: 200px;
  flex: 1;
  min-width: 0;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #CCC;
  border-radius: 3px;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
`;

export const CharacterLimit = styled.div`
  color: ${props => props.warning ? '#9F2A2A' : '#666'};
  font-size: 12px;
  line-height: 16px;
  margin: 6px 0 0 0;
`;
